import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { ComponentRegistry } from 'core';
import { analytics } from 'core/analytics';

import DocumentHead from 'legacyComponents/documentHead';

import { ProjectTypeOption } from 'apps/project/views/projectTypeOption';
import { ProjectTypeItem } from 'apps/project/views/projectTypeItem';

import { HeaderMarginTop as Main, Center } from 'legacyComponents/styled/lib';
import { Link } from 'core/routing';

import { Header } from 'apps/components/header';
import styled from 'styled-components';
import { Button } from 'components';

ComponentRegistry.add('project.projectTypeOption', ProjectTypeOption);
ComponentRegistry.add('project.projectTypeItem', ProjectTypeItem);

@withNamespaces()
@inject('routerStore')
@observer
export class Redirect extends React.Component {
  render() {
    return (
      <div>
        <DocumentHead title='Redirecting to your project...' index='noindex' />

        <Header />
        <Main>
          <Wrapper>
            <Code></Code>
            <Message>
              <Trans>
                We are redirecting you to your project. Just one second...
              </Trans>
            </Message>
            <Center>
              <Link name='home'>
                <ButtonStyled text={<Trans>Back Home</Trans>} />
              </Link>
            </Center>
          </Wrapper>
        </Main>
      </div>
    );
  }

  componentDidMount() {
    const { routerStore } = this.props;
    const { pkceCode, redirectTo } = this.getDropboxDataFromURL(
      window.location.href,
    );

    const codeVerifier = sessionStorage.getItem('pkce-code-verifier');

    const tokenEndpoint = new URL('https://api.dropboxapi.com/oauth2/token');
    fetch(tokenEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: new URLSearchParams({
        code: pkceCode,
        grant_type: 'authorization_code',
        code_verifier: codeVerifier,
        client_id: IMPORTER_DROPBOX_APP_KEY,
        redirect_uri: new URL('redirect', MAIN_URL),
      }),
    })
      .then(response => response.json())
      .then(data => {
        sessionStorage.setItem('temp-access-token', data.access_token);
      })
      .catch(error => {
        analytics.logError(error);
      })
      .finally(() => {
        sessionStorage.removeItem('pkce-code-verifier');
        routerStore.navigate(redirectTo.name, redirectTo.params);
      });
  }

  getDropboxDataFromURL(url) {
    const urlObject = new URL(url.replace('#', '?'));
    const pkceCode = urlObject.searchParams.get('code');
    const state = urlObject.searchParams.get('state');
    const redirectTo = JSON.parse(atob(state));
    return { pkceCode, redirectTo };
  }
}

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100vh - 70px);
  top: 0px;
`;

const Code = styled.h1`
  text-align: center;
  margin-top: ${props => (props.subPage ? '100px' : '220px')};
  font-size: 120px;
  font-weight: bold;
  pointer-events: none;
  margin-bottom: 20px;
`;

const Message = styled.p`
  text-align: center;
  font-size: ${props => (props.small ? '18px' : '22px')};
  font-weight: 600;
`;

const ButtonStyled = styled(Button)`
  margin: ${props => props.theme.spacing.medium};
`;

Redirect.propTypes = {
  t: PropTypes.func,
  routerStore: PropTypes.object,
};
